//HOOKS UTILIZADOS
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

//LIBRERIAS UTILIZADAS
import { object, string } from 'yup';

//COMPONENTES UTILIZADOS
import { Link } from 'react-router-dom'
import Container from './components-login/Container.js'
import Publicidad from './components-login/Publicidad.js'
import Card from './components-login/Card.js'
import Logo from './components-login/Logo.js'
import Button from './components-login/Button.js';
import Formulario from './components-login/Formulario.js'
import { getAuth, logout } from '../app/authSlice.js'

import WarningModal from './components-modals/WarningModal.js'
import Avisos from './Avisos.js'

import { fetchApi } from "../components/tools" // Consumir api

//CONSTANTES
// const headers = {
//   "Authorization": process.env.REACT_APP_TOKEN_API,
//   "Content-ID": process.env.REACT_APP_AUDIENCIA_API,
//   "Content-Type": "application/json"
// }

//COMPONENTE LOGIN
const Login = () => {
  const [enMantenimiento, setEnMantenimiento] = useState(false)   /// MANTENIMIENTO
  const [mostrarAviso, setMostrarAviso] = useState(false)

  const dispatch = useDispatch() //Hook para poder cambiar estados de la store con cualquier componente

  const dirWebApp = process.env.REACT_APP_DIR_PRO

  const headersApi = useSelector((state) => state.url.headersAPI)

  // const urlSeguridad = process.env.REACT_APP_URL_API_PRO_SEG // Para producción
  const urlSeguridad = process.env.REACT_APP_URL_API_SEG // Para pruebas
  const url = process.env.REACT_APP_URL_API // Para pruebas

  const handleSubmit = async (values) => {
    if (values.LoginId.length === 7) {
      const data = await fetchApi({
        url: url + '/perfilalumno/perfilesfamilia',
        headers: headersApi,
        content: {
          IdFamilia: values.LoginId //R23-160
        }
      })
      if (data.msg.length === 1) {
        const dataBloqueado = await fetchApi({
          url: url + '/utils/busquedas',
          headers: headersApi,
          content: {
            opcion: 'BLOQUEADO',
            Carnet: data.msg[0].Carnet
          }
        })
        if (dataBloqueado[0].Bloqueado) {
          setMostrarAviso(true)
        } else {
          setMostrarAviso(false)
          const password = values.password //Encriptación MD5 en el password
          const jsonValues = JSON.stringify({ LoginId: values.LoginId, password: password })
          dispatch(getAuth({
            config: {
              method: "POST", //Propiedad method, "POST", "GET", etc
              url: urlSeguridad + "/seguridad/login", //URL de la API
              headers: headersApi, //Propiedad headers, por si la API solicita token, audiencia, etc
              payload: jsonValues, //Propiedad payload --> datos a enviar en la solicitud http
            },
            rememberUser: values.checked,
          }))
        }
      } else {
        const password = values.password //Encriptación MD5 en el password
        const jsonValues = JSON.stringify({ LoginId: values.LoginId, password: password })
        dispatch(getAuth({
          config: {
            method: "POST", //Propiedad method, "POST", "GET", etc
            url: urlSeguridad + "/seguridad/login", //URL de la API
            headers: headersApi, //Propiedad headers, por si la API solicita token, audiencia, etc
            payload: jsonValues, //Propiedad payload --> datos a enviar en la solicitud http
          },
          rememberUser: values.checked,
        }))
      }
    } else {
      const password = values.password //Encriptación MD5 en el password
      const jsonValues = JSON.stringify({ LoginId: values.LoginId, password: password })
      dispatch(getAuth({
        config: {
          method: "POST", //Propiedad method, "POST", "GET", etc
          url: urlSeguridad + "/seguridad/login", //URL de la API
          headers: headersApi, //Propiedad headers, por si la API solicita token, audiencia, etc
          payload: jsonValues, //Propiedad payload --> datos a enviar en la solicitud http
        },
        rememberUser: values.checked,
      }))
    }
  }

  const error = useSelector((state) => state.auth.error)
  let errorMsg = ''
  switch (error?.Error) {
    case '1002':
      errorMsg = 'Usuario incorrecto'
      break
    case '1003':
      errorMsg = 'Contraseña incorrecta'
      break
    case '1001':
      errorMsg = 'Inconveniente en el sistema'
      break
    default:
      console.log(error)
  }

  const isIdleTimeOut = useSelector(state => state.auth.inactivity) //Trigger que dispara el modal de tiempo excedido de inactividad 

  return (

    <>
      <WarningModal
        open={isIdleTimeOut ? true : false}
        image={
          <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-5 icon icon-tabler icon-tabler-alert-octagon" width="60" height="60" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#e89545" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        }
        title='Aviso'
        subtitle={<span>Limite de tiempo de inactividad excedido, por favor inicie sesión de nuevo.</span>}
        opacity='bg-opacity-50'
      >
        <div className="mt-5 sm:mt-6">
          <Button
            onClick={() => dispatch(logout())}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Iniciar sesión
          </Button>
        </div>
      </WarningModal>

      <div className='elementFadeIn flex items-center justify-center h-screen w-full bg-secundarioMira bg-auto'> {/* Para agregar imagen de fondo agregar la siguiente clase bg-[url("/public/img/fondo.jpg")] */}
        {enMantenimiento ?

          <p className={"animate-bounce text-4xl text-white"}>Campus en mantenimiento, gracias por su comprensión</p>
          :
          mostrarAviso ?
            <div className="flex items-center justify-center h-screen">
              <Avisos setEstado={setMostrarAviso} />
            </div>
            :
            <Container>
              <Publicidad slides={
                [
                  {
                    alt: 'Slide publicitaria #1',
                    src: 'img/publicidad1.png'
                  },
                  {
                    alt: 'Slide publicitaria #2',
                    src: 'img/publicidad2.png'
                  },
                  {
                    alt: 'Slide publicitaria #3',
                    src: 'img/publicidad3.png'
                  },
                ]
              } />
              <Card>
                {error ? <div className='font-extrabold text-center text-red-700'>{errorMsg}</div> : null}
                <div
                  className="mx-auto mb-4 mt-1">
                  <Logo alt='icono imb-pc' src='./img/Logo-xl.png'
                  />
                </div>
                <Formulario
                  initialValues={{ LoginId: '', password: '', checked: false }}
                  onSubmit={handleSubmit}
                  validationSchema={object({
                    LoginId: string().required('Dato obligatorio'),
                    password: string().required('Dato obligatorio')
                  })} />
                <Button className='font-semibold text-center  hover:underline text-white mt-6'>
                  <Link to={`${dirWebApp}recuperarCuenta`}>
                    ¿Has olvidado tu contraseña?
                  </Link>
                </Button>
                <Button className='font-semibold text-center  hover:underline text-secundario mt-6'>
                  <a
                    target="_blank"
                    href={`https://www.imb-pc.com/campusv3/`}>
                    Regresar al campus anterior
                  </a>
                </Button>
              </Card>
            </Container>
        }
      </div>

    </>
  )
}

export default Login;